document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.collection-carousel').forEach(function (section) {
    var scroller = section.querySelector('.collection-carousel__scroller');
    var arrows = section.querySelectorAll('.collection-carousel__arrow');
    if (!scroller || !arrows.length) return;

    arrows.forEach(function (arrow) {
      arrow.addEventListener('click', function () {
        var direction = parseInt(arrow.getAttribute('data-direction'), 10);
        var tile = scroller.querySelector('.collection-carousel__tile');
        var tileWidth = tile ? tile.getBoundingClientRect().width + 16 : 240;
        scroller.scrollBy({ left: direction * tileWidth * 2, behavior: 'smooth' });
      });
    });
  });
});
